export default  {
    tipoEndosso: {
        COBRANCA: 1,
        RESTITUICAO: 2,
        EXCLUSAO: 3, 
        CANCELAMENTO: 4, 
        SUBSTITUICAO: 5,
        ALTERACAO:6, 
        GATILHO:7
    }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-endosso-enum.js